import React, { PureComponent } from 'react';
import { Marker} from 'react-leaflet';

import { sortByKey, isNumeric } from '~/core/scripts/utils';
import { getCentroid } from '~/kits/general/scripts/utils';

class RankingMarker extends PureComponent {
  constructor(props) {
    super();

    const { valueKey, data, geojson, inverted = false } = props;
    const key = valueKey === 'greenestIndex' ? 'rank' : valueKey;

    this.data = data
      .filter(d => isNumeric(d[key]) && !['888', '999'].includes(d.AGS))
      .sort(sortByKey(key, !inverted))
      .slice(0, 3)
      .map(d => {
        const position = getCentroid(geojson, d.AGS);

        return {
          ...d,
          position: position
        };
      });
  }

  render() {
    return this.data.map((d, i) => {
      const icon = L.divIcon({ className: 'map-label ranking-marker', html: i + 1 });
      return (
        <Marker
          key={`MapLabelRanking__${i}`}
          position={d.position}
          icon={icon}
        />
      );
    });
  }
}

export default RankingMarker;
